module.exports = __webpack_public_path__ + "static/media/sad.6513c338.svg";